// import { render } from "@testing-library/react";
// import React, { Suspense, useContext, useEffect } from "react";
// import { useState } from "react";

// import { Link } from "react-router-dom";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// import $ from "jquery";
// import { GetEmpAssessmentPeriodList } from "./PMSService";
// import moment from "moment";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
// import { TostMsg } from "../../../App";
// import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
// const HrAssessment = () => {
//   let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
//   const [EmpAssessmentList, setEmpAssessmentList] = useState([]);
//   const [EmpAssessmentListCount, setEmpAssessmentListCount] = useState([]);
//   const history = useHistory();
//   const [Isloading, setIsloading] = useState(false);
//   const toster = useContext(TostMsg);

//   useEffect(() => {
//     getEmpAssessmentPeriodList()
//   }, []);

//   async function getEmpAssessmentPeriodList() {
//     setIsloading(true);
//     const body = {
//       OrgId: userDetails?.OrgId,
//       LoggedInUserId: userDetails?.EmpId,
//       tblOrgAssessmentPeriodGuId: "",
//       Search: "",
//       PageNumber: 1,
//       PageSize: 1000
//     }
//     try {
//       let LikeList = await GetEmpAssessmentPeriodList(body);
//       setEmpAssessmentListCount(LikeList?.Data);
//       setEmpAssessmentList(LikeList?.Data?.assessmentPresiodResponse);
//       setIsloading(false);
//     } catch (error) {
//       setIsloading(false);
//       toster.current.error(ERROR_LIST?.EmpAssessmentList);
//     }
//   }

//   const myFunction = () => {
//     var x = document.getElementById("myDIV2");
//     if (x.style.display === "block") {
//       x.style.display = "none";
//     } else {
//       x.style.display = "block";
//     }
//   }

//   const showPopup = () => {
//     $(".Show-upload-div").click(function () {
//       $(".upload-img").show("slow");
//     });
//     $(".Hide-upload-div").click(function () {
//       $(".upload-img").hide("slow");
//     });
//   }
//   const ShowUploadDiv2 = () => {
//     $(".Show-upload-div2").click(function () {
//       $(".upload-emoji").show("slow");
//     });
//     $(".Hide-upload-div2").click(function () {
//       $(".upload-emoji").hide("slow");
//     });
//   }

//   const navigatePage = (guid) => {
//     window.open(`/Assessment/Cycle/${guid}`, '_blank');
//     // history?.push(`/Assessment/Cycle/${guid}`)
//   }

//    const navigateAddAssessmentPage = ()=>{
//     history.push('/Assessment/AddNewAssessment')
//   }

//   return (
//     <div>
//       <div id="circular-menu" className="circular-menu">
//         <a className="floating-btn">
//           <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
//           <i aria-hidden="true" className="fa fa-times"></i>
//         </a>

//         <div className="items-wrapper">
//           <div className="menu-item is-flex">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="feather feather-bell"
//             >
//               <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
//               <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
//             </svg>
//           </div>
//           <a
//             className="menu-item is-flex right-panel-trigger"
//             data-panel="languages-panel"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="feather feather-bell"
//             >
//               <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
//               <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
//             </svg>
//           </a>
//           <Link to="" className="menu-item is-flex">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="feather feather-bell"
//             >
//               <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
//               <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
//             </svg>
//           </Link>
//           <a
//             className="menu-item is-flex right-panel-trigger"
//             data-panel="activity-panel"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="feather feather-grid"
//             >
//               <rect x="3" y="3" width="7" height="7"></rect>
//               <rect x="14" y="3" width="7" height="7"></rect>
//               <rect x="14" y="14" width="7" height="7"></rect>
//               <rect x="3" y="14" width="7" height="7"></rect>
//             </svg>
//           </a>
//         </div>
//       </div>
//       {/* <!-- row --> */}
//       <div className="container-fluid">
//         <div className="row g-3 assessment-module">
//           <div className="col-xl-12">
//             <div className="form-head d-flex flex-wrap align-items-center">
//               <div className="me-auto">
//                 <h2 className="font-w600 mb-0">Assessment Cycles</h2>
//               </div>
//               <div className="rightside-tabs">
//                 {/* <select className='form-control'>
//                                         <option disabled>Select Period</option>
//                                         <option selected >01 April 2022 - 31 March 2023</option>
//                                         <option>01 April 2021 - 31 March 2022</option>
//                                         <option>01 April 2020 - 31 March 2021</option>
//                                     </select> */}

//                 <button
//                   className="add-newticket w-auto float-right"
//                   style={{ minWidth: "fit-content" }}
//                    onClick={ ()=>navigateAddAssessmentPage()}
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="20"
//                     height="20"
//                     fill="currentColor"
//                     className="bi bi-plus"
//                     viewBox="0 0 16 16"
//                   >
//                     <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
//                   </svg>
//                   New Assessment
//                 </button>
//               </div>
//             </div>
//           </div>
//           <div className="col-xl-12">
//             <div className="page-content-inner all-projects mt-0">
//               <div className="tickets-summary">
//                 <div className="column">
//                   <img src="images/org-img/leave/popup-backimg.png" />
//                   <div className="dashboard-tile">
//                     <div className="tile-head">
//                       <h3 className="dark-inverted">Avg Employee Tenure</h3>
//                       <div className="h-icon is-primary is-rounded is-small">
//                         <i aria-hidden="true" className="fas fa-gem"></i>
//                       </div>
//                     </div>
//                     <div className="tile-body">
//                       <span className="dark-inverted">00</span>
//                     </div>
//                     <div className="tile-foot">
//                       <span className="text-h-green"></span>
//                       <span>Current</span>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="column">
//                   <img src="images/org-img/leave/popup-backimg.png" />
//                   <div className="dashboard-tile">
//                     <div className="tile-head">
//                       <h3 className="dark-inverted">Per Cycle</h3>
//                       <div className="h-icon is-primary is-rounded is-small">
//                         <i aria-hidden="true" className="fas fa-gem"></i>
//                       </div>
//                     </div>
//                     <div className="tile-body">
//                       <span className="dark-inverted">10</span>
//                     </div>
//                     <div className="tile-foot">
//                       <span className="text-h-green"></span>
//                       <span>Avg. Duration</span>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="column">
//                   <img src="images/org-img/leave/popup-backimg.png" />
//                   <div className="dashboard-tile">
//                     <div className="tile-head">
//                       <h3 className="dark-inverted">Self Review</h3>
//                       <div className="h-icon is-primary is-rounded is-small">
//                         <i aria-hidden="true" className="fas fa-gem"></i>
//                       </div>
//                     </div>
//                     <div className="tile-body">
//                       <span className="dark-inverted">15</span>
//                     </div>
//                     <div className="tile-foot">
//                       <span className="text-h-green"></span>
//                       <span>Avg. Duration</span>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="column">
//                   <img src="images/org-img/leave/popup-backimg.png" />
//                   <div className="dashboard-tile">
//                     <div className="tile-head">
//                       <h3 className="dark-inverted">Manager Review</h3>
//                       <div className="h-icon is-primary is-rounded is-small">
//                         <i aria-hidden="true" className="fas fa-gem"></i>
//                       </div>
//                     </div>
//                     <div className="tile-body">
//                       <span className="dark-inverted">12</span>
//                     </div>
//                     <div className="tile-foot">
//                       <span className="text-h-green"></span>
//                       <span>Avg. Duration</span>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="column">
//                   <img src="images/org-img/leave/popup-backimg.png" />
//                   <div className="dashboard-tile">
//                     <div className="tile-head">
//                       <h3 className="dark-inverted">Senior Level Review</h3>
//                       <div className="h-icon is-primary is-rounded is-small">
//                         <i aria-hidden="true" className="fas fa-gem"></i>
//                       </div>
//                     </div>
//                     <div className="tile-body">
//                       <span className="dark-inverted">08</span>
//                     </div>
//                     <div className="tile-foot">
//                       <span className="text-h-green"></span>
//                       <span>Avg. Duration</span>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="column">
//                   <img src="images/org-img/leave/popup-backimg.png" />
//                   <div className="dashboard-tile">
//                     <div className="tile-head">
//                       <h3 className="dark-inverted">Avg. Rating</h3>
//                       <div className="h-icon is-primary is-rounded is-small">
//                         <i aria-hidden="true" className="fas fa-gem"></i>
//                       </div>
//                     </div>
//                     <div className="tile-body">
//                       <span className="dark-inverted">05</span>
//                     </div>
//                     <div className="tile-foot">
//                       <span className="text-h-green"></span>
//                       <span>Current</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {EmpAssessmentList?.map((el) => (
//             <div className="col-xl-9">
//               <p className="status-category">{el?.AssessmentPeriodStatus}</p>
//               <div className="assessment-block">
//                 <div className="illustration-header00">
//                   <div className="header-meta">
//                     <div className="first-divblock">
//                       <div>
//                         <h3>{el?.AssesmentTemplateName}</h3>
//                         <ul className="basicinfomation">
//                           {/* <li><i className="fa fa-calendar" aria-hidden="true"></i>01 Apr 2022- 31 Mar 2023</li> */}
//                           <li>
//                             <i className="fa fa-user-o" aria-hidden="true"></i>
//                             Total Employee : <b className="emp-count">{el?.TotalEligibleEmployees}</b>
//                           </li>
//                         </ul>
//                       </div>
//                       <div className="ml-auto">
//                         <span className="assessment-status-initiated">
//                           Initiated
//                         </span>
//                         <span className="assessment-view-detail" onClick={() => navigatePage(el?.GUID)}>
//                           View Detail
//                         </span>
//                       </div>
//                     </div>
//                     <div className="summary-stats">
//                       <div className="summary-stat">
//                         <img src="images/pms/start-date.svg" />
//                         <div>
//                           <span>Initiated On</span>
//                           <span>{moment(el?.StartedOn).format("MMM DD YYYY")}</span>
//                         </div>
//                       </div>
//                       <div className="summary-stat">
//                         <img src="images/pms/start-date.svg" />
//                         <div>
//                           <span>Self Assessment By</span>
//                           <span>{moment(el?.SelfAssesmentClosureDate).format("MMM DD YYYY")}</span>
//                         </div>
//                       </div>
//                       <div className="summary-stat">
//                         <img src="images/pms/end-date.svg" />
//                         <div>
//                           <span>First Review By</span>
//                           <span>{moment(el?.FirstReviewerClosureDate).format("MMM DD YYYY")}</span>
//                         </div>
//                       </div>
//                       <div className="summary-stat">
//                         <img src="images/pms/date.svg" />
//                         <div>
//                           <span>Assessment Closure By</span>
//                           <span>{moment(el?.EndedOn).format("MMM DD YYYY")}</span>
//                         </div>
//                       </div>
//                     </div>
//                     {/* <div className="emprightside-tabss"><div className="stepper-wrapper00"><div className="stepper-item completed">
//                                             <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
//                                                 <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
//                                             </svg></div>
//                                             <div className="step-name">Initiated</div>
//                                         </div>
//                                             <div className="stepper-item completed">
//                                                 <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
//                                                     <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
//                                                 </svg></div>
//                                                 <div className="step-name">Submitted</div>
//                                             </div>
//                                             <div className="stepper-item active">
//                                                 <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
//                                                     <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
//                                                 </svg></div>
//                                                 <div className="step-name">Reviewed</div>
//                                             </div>
//                                             <div className="stepper-item active">
//                                                 <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
//                                                     <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
//                                                 </svg></div>
//                                                 <div className="step-name">Closed</div>
//                                             </div>
//                                         </div>
//                                         </div> */}
//                   </div>
//                 </div>
//               </div>
//             </div>))}

//           {/* <p className="status-category">Completed</p>
//             <div className="assessment-block">
//               <div className="illustration-header00">
//                 <div className="header-meta">
//                   <div className="first-divblock">
//                     <div>
//                       <h3>FY 23-24 Yearly Review</h3>
//                       <ul className="basicinfomation">
//                         <li>
//                           <i className="fa fa-user" aria-hidden="true"></i>
//                           Total Employee : <b className="emp-count">05</b>
//                         </li>
//                       </ul>
//                     </div>
//                     <div className="ml-auto">
//                       <span className="assessment-status-close">Closed</span>
//                       <span className="assessment-view-detail">
//                         View Detail
//                       </span>
//                     </div>
//                   </div>
//                   <div className="summary-stats">
//                     <div className="summary-stat">
//                       <img src="images/pms/start-date.svg" />
//                       <div>
//                         <span>Initiated On</span>
//                         <span>08 May 2023</span>
//                       </div>
//                     </div>
//                     <div className="summary-stat">
//                       <img src="images/pms/start-date.svg" />
//                       <div>
//                         <span>Self Assessment By</span>
//                         <span>15 May 2023</span>
//                       </div>
//                     </div>
//                     <div className="summary-stat">
//                       <img src="images/pms/end-date.svg" />
//                       <div>
//                         <span>First Review By</span>
//                         <span>22 May 2023</span>
//                       </div>
//                     </div>
//                     <div className="summary-stat">
//                       <img src="images/pms/date.svg" />
//                       <div>
//                         <span>Assessment Closure By</span>
//                         <span>26 May 2023</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="assessment-block">
//               <div className="illustration-header00">
//                 <div className="header-meta">
//                   <div className="first-divblock">
//                     <div>
//                       <h3>FY 22-23 Yearly Review</h3>
//                       <ul className="basicinfomation">
//                         <li>
//                           <i className="fa fa-user" aria-hidden="true"></i>
//                           Total Employee : <b className="emp-count">05</b>
//                         </li>
//                       </ul>
//                     </div>
//                     <div className="ml-auto">
//                       <span className="assessment-status-close">Closed</span>
//                       <span className="assessment-view-detail">
//                         View Detail
//                       </span>
//                     </div>
//                   </div>
//                   <div className="summary-stats">
//                     <div className="summary-stat">
//                       <img src="images/pms/start-date.svg" />
//                       <div>
//                         <span>Initiated On</span>
//                         <span>08 May 2023</span>
//                       </div>
//                     </div>
//                     <div className="summary-stat">
//                       <img src="images/pms/start-date.svg" />
//                       <div>
//                         <span>Self Assessment By</span>
//                         <span>15 May 2023</span>
//                       </div>
//                     </div>
//                     <div className="summary-stat">
//                       <img src="images/pms/end-date.svg" />
//                       <div>
//                         <span>First Review By</span>
//                         <span>22 May 2023</span>
//                       </div>
//                     </div>
//                     <div className="summary-stat">
//                       <img src="images/pms/date.svg" />
//                       <div>
//                         <span>Assessment Closure By</span>
//                         <span>26 May 2023</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div> */}

//           <div className="col-xl-3">
//             <p className="status-category">Process</p>
//             <OwlCarousel loop margin={10} nav items={1} autoplay={true}
//               autoplayTimeout={3000}
//               autoplayHoverPause={true}>
//               <div className="review-step">
//                 <span>01</span>
//                 <img
//                   src="https://huro.cssninja.io/assets/img/illustrations/widgets/1.svg"
//                   style={{ width: "160px", margin: "auto auto 20px" }}
//                 />
//                 <h4>Goal Setting</h4>
//                 <p>
//                   Every start of year, set some goals for yourself. Progress is
//                   generally good when you follow a goal
//                 </p>

//               </div>
//               <div className="review-step">
//                 <span>02</span>
//                 <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/7.svg" />
//                 <h4>Self Assessment</h4>
//                 <p>
//                   Once review process is started, List down all your success and
//                   failures, all good and bad and rate yourself
//                 </p>
//               </div>
//               <div className="review-step">
//                 <span>03</span>
//                 <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/8.svg" />
//                 <h4>Manager Assessment</h4>
//                 <p>
//                   It is managers duty to review your performance without any
//                   prejudice. It should be based on actual outcomes of your
//                   efforts
//                 </p>
//               </div>
//               <div className="review-step">
//                 <span>04</span>
//                 <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/4.svg" />
//                 <h4>Recomendation</h4>
//                 <p>
//                   Based on your review and your managers assessment, senior
//                   management may recommend you new goals, role and
//                   responsibilities
//                 </p>
//               </div>
//               <div className="review-step">
//                 <span>05</span>
//                 <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/7.svg" />
//                 <h4>One-on-One meeting</h4>
//                 <p>
//                   Use this to discuss all your doubts and chalk out the startegy
//                   to do better this year
//                 </p>
//               </div>
//             </OwlCarousel>
//           </div>
//           <div className="col-xl-12 d-none">
//             <strong className="assessment-title">Eligible Employees</strong>
//             <div className="card">
//               <div className="card-body">
//                 <div className="form-head d-flex flex-wrap align-items-center mb-4">
//                   <div className="me-auto w-50">
//                     <input
//                       type="text"
//                       placeholder="search..."
//                       className="form-control"
//                       style={{ height: "41px" }}
//                     />
//                   </div>
//                   <div className="saving-btn00">
//                     <button
//                       className="add-m saveby-employee me-2"
//                       data-toggle="tooltip"
//                       data-placement="top"
//                       title="Add"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         fill="currentColor"
//                         className="bi bi-plus-lg"
//                         viewBox="0 0 16 16"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
//                         />
//                       </svg>
//                     </button>
//                     <button
//                       className="update-m submitby-employee me-2"
//                       data-toggle="tooltip"
//                       data-placement="top"
//                       title="Update"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         fill="currentColor"
//                         className="bi bi-arrow-clockwise"
//                         viewBox="0 0 16 16"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
//                         />
//                         <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
//                       </svg>
//                     </button>
//                     <button
//                       className="remove-m submitby-employer me-2"
//                       data-toggle="tooltip"
//                       data-placement="top"
//                       title="Remove"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         fill="currentColor"
//                         className="bi bi-trash"
//                         viewBox="0 0 16 16"
//                       >
//                         <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
//                         <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
//                       </svg>
//                     </button>
//                     <button
//                       className="import-m saveby-employee me-2"
//                       data-toggle="tooltip"
//                       data-placement="top"
//                       title="Import"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         fill="currentColor"
//                         className="bi bi-box-arrow-in-down"
//                         viewBox="0 0 16 16"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
//                         />
//                         <path
//                           fillRule="evenodd"
//                           d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
//                         />
//                       </svg>
//                     </button>
//                     <button
//                       className="export-m submitby-employee me-2"
//                       data-toggle="tooltip"
//                       data-placement="top"
//                       title="Export"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         fill="currentColor"
//                         className="bi bi-box-arrow-in-up"
//                         viewBox="0 0 16 16"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
//                         />
//                         <path
//                           fillRule="evenodd"
//                           d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
//                         />
//                       </svg>
//                     </button>
//                     <button
//                       className="assign-m submitby-employer me-2"
//                       data-toggle="tooltip"
//                       data-placement="top"
//                       title="Assign"
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="16"
//                         height="16"
//                         fill="currentColor"
//                         className="bi bi-clipboard-check"
//                         viewBox="0 0 16 16"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
//                         />
//                         <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
//                         <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="employee-card tile-grid tile-grid-v1">
//                     <div className="table-responsive emp-table">
//                       {/* dataTable no-footer */}
//                       <table
//                         id="example"
//                         className="table table-striped table-bordered dataTable no-footer"
//                         style={{ width: "100%" }}
//                       >
//                         <thead>
//                           <tr>
//                             <th style={{ width: "50px" }}>
//                               <div className="form-check custom-checkbox checkbox-success check-lg">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="checkAll"
//                                   required=""
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="checkAll"
//                                 ></label>
//                               </div>
//                             </th>
//                             <th>Name</th>
//                             <th>Status</th>
//                             <th>Assigned To</th>
//                             <th>Score</th>
//                             <th>Rating</th>
//                             <th>Rating Scale</th>
//                             <th>First Reviewer</th>
//                             <th>Second Reviewer</th>
//                             <th>HR</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           <tr className="odd">
//                             <td>
//                               <div className="form-check custom-checkbox checkbox-success check-lg">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customCheckBox2"
//                                   required=""
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="customCheckBox2"
//                                 ></label>
//                               </div>
//                             </td>
//                             <td>
//                               <Link to="UserProfile">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     src="images/avatar/6.jpg"
//                                     className="rounded-lg me-2"
//                                     width="24"
//                                     alt=""
//                                   />{" "}
//                                   <span className="w-space-no">
//                                     Savita Rana
//                                   </span>
//                                 </div>
//                               </Link>
//                             </td>
//                             <td>Closed</td>
//                             <td>
//                               Arun Mishra
//                               <span className="caption-name">
//                                 (Second Reviewer)
//                               </span>{" "}
//                             </td>
//                             <td>
//                               3.9
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Vital Performance</td>
//                             <td>
//                               4
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Alisha Goyal</td>
//                             <td>Arun Mishra</td>
//                             <td>Pragya Tiwari</td>
//                             <td>
//                               <div className="d-flex">
//                                 <a className="btn btn-primary shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-pencil-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn btn-danger shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-trash3-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn badge light badge-success shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-send-check-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
//                                     <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
//                                   </svg>
//                                 </a>
//                               </div>
//                             </td>
//                           </tr>
//                           <tr className="even">
//                             <td>
//                               <div className="form-check custom-checkbox checkbox-success check-lg">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customCheckBox2"
//                                   required=""
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="customCheckBox2"
//                                 ></label>
//                               </div>
//                             </td>
//                             <td>
//                               <Link to="UserProfile">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     src="images/avatar/8.jpg"
//                                     className="rounded-lg me-2"
//                                     width="24"
//                                     alt=""
//                                   />{" "}
//                                   <span className="w-space-no">Sonal</span>
//                                 </div>
//                               </Link>
//                             </td>
//                             <td>Pending</td>
//                             <td>
//                               Alisha Goyal
//                               <span className="caption-name">
//                                 (Second Reviewer)
//                               </span>{" "}
//                             </td>
//                             <td>
//                               3.9
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Key Performer</td>
//                             <td>
//                               4
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Alisha Goyal</td>
//                             <td>Arun Mishra</td>
//                             <td>Pragya Tiwari</td>
//                             <td>
//                               <div className="d-flex">
//                                 <a className="btn btn-primary shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-pencil-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn btn-danger shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-trash3-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn badge light badge-success shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-send-check-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
//                                     <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
//                                   </svg>
//                                 </a>
//                               </div>
//                             </td>
//                           </tr>
//                           <tr className="odd">
//                             <td>
//                               <div className="form-check custom-checkbox checkbox-success check-lg">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customCheckBox2"
//                                   required=""
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="customCheckBox2"
//                                 ></label>
//                               </div>
//                             </td>
//                             <td>
//                               <Link to="UserProfile">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     src="images/avatar/1.jpg"
//                                     className="rounded-lg me-2"
//                                     width="24"
//                                     alt=""
//                                   />{" "}
//                                   <span className="w-space-no">
//                                     Anubhav Singh
//                                   </span>
//                                 </div>
//                               </Link>
//                             </td>
//                             <td>Pending</td>
//                             <td>
//                               Alisha Goyal
//                               <span className="caption-name">
//                                 (Second Reviewer)
//                               </span>{" "}
//                             </td>
//                             <td>
//                               3.9
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Key Performer</td>
//                             <td>
//                               4
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Alisha Goyal</td>
//                             <td>Arun Mishra</td>
//                             <td>Pragya Tiwari</td>
//                             <td>
//                               <div className="d-flex">
//                                 <a className="btn btn-primary shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-pencil-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn btn-danger shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-trash3-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn badge light badge-success shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-send-check-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
//                                     <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
//                                   </svg>
//                                 </a>
//                               </div>
//                             </td>
//                           </tr>
//                           <tr className="even">
//                             <td>
//                               <div className="form-check custom-checkbox checkbox-success check-lg">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customCheckBox2"
//                                   required=""
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="customCheckBox2"
//                                 ></label>
//                               </div>
//                             </td>

//                             <td>
//                               <Link to="UserProfile">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     src="images/avatar/2.jpg"
//                                     className="rounded-lg me-2"
//                                     width="24"
//                                     alt=""
//                                   />{" "}
//                                   <span className="w-space-no">
//                                     Dharmesh tyagi
//                                   </span>
//                                 </div>
//                               </Link>
//                             </td>
//                             <td>Pending</td>
//                             <td>
//                               Alisha Goyal
//                               <span className="caption-name">
//                                 (Second Reviewer)
//                               </span>{" "}
//                             </td>
//                             <td>
//                               3.9
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Key Performer</td>
//                             <td>
//                               4
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Alisha Goyal</td>
//                             <td>Arun Mishra</td>
//                             <td>Pragya Tiwari</td>
//                             <td>
//                               <div className="d-flex">
//                                 <a className="btn btn-primary shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-pencil-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn btn-danger shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-trash3-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn badge light badge-success shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-send-check-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
//                                     <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
//                                   </svg>
//                                 </a>
//                               </div>
//                             </td>
//                           </tr>
//                           <tr className="odd">
//                             <td>
//                               <div className="form-check custom-checkbox checkbox-success check-lg">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customCheckBox2"
//                                   required=""
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor="customCheckBox2"
//                                 ></label>
//                               </div>
//                             </td>
//                             <td>
//                               <Link to="UserProfile">
//                                 <div className="d-flex align-items-center">
//                                   <img
//                                     src="images/avatar/3.jpg"
//                                     className="rounded-lg me-2"
//                                     width="24"
//                                     alt=""
//                                   />{" "}
//                                   <span className="w-space-no">Rashika</span>
//                                 </div>
//                               </Link>
//                             </td>
//                             <td>Pending</td>
//                             <td>
//                               Alisha Goyal
//                               <span className="caption-name">
//                                 (Second Reviewer)
//                               </span>{" "}
//                             </td>
//                             <td>
//                               3.9
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Key Performer</td>
//                             <td>
//                               4
//                               <ul className="score-rate">
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star"></i>
//                                 </li>
//                                 <li>
//                                   <i className="fa fa-star no-star"></i>
//                                 </li>
//                               </ul>
//                             </td>
//                             <td>Alisha Goyal</td>
//                             <td>Arun Mishra</td>
//                             <td>Pragya Tiwari</td>
//                             <td>
//                               <div className="d-flex">
//                                 <a className="btn btn-primary shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-pencil-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn btn-danger shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-trash3-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
//                                   </svg>
//                                 </a>
//                                 <a className="btn badge light badge-success shadow btn-xs sharp me-1">
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="12"
//                                     height="12"
//                                     fill="currentColor"
//                                     className="bi bi-send-check-fill"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
//                                     <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
//                                   </svg>
//                                 </a>
//                               </div>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="modal fade" id="add-new-assessment">
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <img src="images/pms/new-assess.gif" />
//               <strong className="modal-title text-center d-block">
//                 Start New Assessment
//               </strong>
//               <p className=" text-center d-block">
//                 Do you really want to Report this post ?
//               </p>
//               <div className="row mt-3">
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Title</label>
//                     <input type="text" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Review By</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Assessment Period Start</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Assessment Period End</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Assessment Start</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Assessment End</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>Self Assessment Last Date</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="form-group">
//                     <label>First Reviewer Last Date</label>
//                     <input type="date" className="form-control" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer m-auto">
//               <button
//                 type="button"
//                 className="btn btn-danger light"
//                 data-bs-dismiss="modal"
//               >
//                 Close
//               </button>
//               <button type="button" className="btn btn-primary">
//                 Send
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       {Isloading ? (
//         <Suspense>
//           <ComponentLoader />
//         </Suspense>
//       ) : (
//         ""
//       )}
//     </div>
//   );
// }

// export default HrAssessment;

import { render } from "@testing-library/react";
import React, { useContext, useEffect } from "react";
import { useState } from "react";

import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import $ from "jquery";
import { GetEmpAssessmentPeriodList } from "../PMSService";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const HrAssessmentHTML = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [EmpAssessmentList, setEmpAssessmentList] = useState([]);
  const [EmpAssessmentListCount, setEmpAssessmentListCount] = useState([]);
  const toster = useContext(TostMsg);

  useEffect(() => {
    // getEmpAssessmentPeriodList();
  }, []);

  async function getEmpAssessmentPeriodList() {
    const body = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      tblOrgAssessmentPeriodGuId: "",
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
    };
    try {
      let LikeList = await GetEmpAssessmentPeriodList(body);
      setEmpAssessmentListCount(LikeList?.Data);
      setEmpAssessmentList(LikeList?.Data?.assessmentPresiodResponse);
    } catch (error) {
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }

  const myFunction = () => {
    var x = document.getElementById("myDIV2");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
  };

  const showPopup = () => {
    $(".Show-upload-div").click(function () {
      $(".upload-img").show("slow");
    });
    $(".Hide-upload-div").click(function () {
      $(".upload-img").hide("slow");
    });
  };
  const ShowUploadDiv2 = () => {
    $(".Show-upload-div2").click(function () {
      $(".upload-emoji").show("slow");
    });
    $(".Hide-upload-div2").click(function () {
      $(".upload-emoji").hide("slow");
    });
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Assessment Cycles</h2>
              </div>
              <div className="rightside-tabs">
                {/* <select className='form-control'>
                                        <option disabled>Select Period</option>
                                        <option selected >01 April 2022 - 31 March 2023</option>
                                        <option>01 April 2021 - 31 March 2022</option>
                                        <option>01 April 2020 - 31 March 2021</option>
                                    </select> */}
                <Link to="/Assessment/AddNewAssessment">
                  <button
                    className="add-newticket w-auto float-right"
                    style={{ minWidth: "fit-content" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Assessment
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="tickets-summary">
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg Employee Tenure</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">00</span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Per Cycle</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">10</span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Self Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">15</span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Manager Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">12</span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Senior Level Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">08</span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Avg. Duration</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg. Rating</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">05</span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-9">
            <p className="status-category">Current</p>
            <div className="assessment-block">
              <div className="illustration-header00">
                <div className="header-meta">
                  <div className="first-divblock">
                    <div>
                      <h3>FY 24-25 Yearly Review</h3>
                      <ul className="basicinfomation">
                        {/* <li><i className="fa fa-calendar" aria-hidden="true"></i>01 Apr 2022- 31 Mar 2023</li> */}
                        <li>
                          <i className="fa fa-user-o" aria-hidden="true"></i>
                          Total Employee : <b className="emp-count">05</b>
                        </li>
                      </ul>
                    </div>
                    <div className="ml-auto">
                      <span className="assessment-status-initiated">
                        Initiated
                      </span>
                       <Link to="/Assessment/Cycle/CycleGUID">
                      <span className="assessment-view-detail">
                        View Detail
                      </span></Link>
                    </div>
                    {/* <div className="saving-btnhr">
                                                <div className="progress">
                                                    <div className="progress-bar progress-bar-success progress-bar-striped" role="progressbar"
                                                        aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ 'width': '60%' }}>
                                                        60% Complete
                                                    </div>
                                                </div>
                                                <button className="add-m saveby-employee" data-toggle="tooltip" data-placement="top" title="Start">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-play-fill" viewBox="0 0 16 16">
                                                        <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                                                    </svg></button>
                                                <button className="update-m submitby-employee" data-toggle="tooltip" data-placement="top" title="Pause">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pause-circle" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z" />
                                                    </svg></button>
                                                <button className="remove-m submitby-employer" data-toggle="tooltip" data-placement="top" title="Remove">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                                    </svg></button>
                                                <button className="import-m saveby-employee" data-toggle="tooltip" data-placement="top" title="Edit">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                                                    </svg></button>
                                                <button className="view-m saveby-employee me-2" data-toggle="tooltip" data-placement="top" title="View">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                            </svg></button>
                                                <button className="assign-m submitby-employer" data-toggle="tooltip" data-placement="top" title="Send reminder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send-check" viewBox="0 0 16 16">
                                                        <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z" />
                                                        <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                                    </svg></button>
                                            </div> */}
                  </div>
                  <div className="summary-stats">
                    {/* <div className="summary-stat">
                                                            <img src='images/pms/hr.jpg' className='hr-img' />
                                                            <div>
                                                                <span>Pragya Tiwari</span>
                                                                <span>(HR Normalization)</span>
                                                            </div>
                                                        </div> */}
                    <div className="summary-stat">
                      <img src="images/pms/start-date.svg" />
                      <div>
                        <span>Initiated On</span>
                        <span>08 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/start-date.svg" />
                      <div>
                        <span>Self Assessment By</span>
                        <span>15 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/end-date.svg" />
                      <div>
                        <span>First Review By</span>
                        <span>22 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/date.svg" />
                      <div>
                        <span>Assessment Closure By</span>
                        <span>26 May 2023</span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="emprightside-tabss"><div className="stepper-wrapper00"><div className="stepper-item completed">
                                            <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
                                                <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                            </svg></div>
                                            <div className="step-name">Initiated</div>
                                        </div>
                                            <div className="stepper-item completed">
                                                <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
                                                    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                </svg></div>
                                                <div className="step-name">Submitted</div>
                                            </div>
                                            <div className="stepper-item active">
                                                <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
                                                    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                </svg></div>
                                                <div className="step-name">Reviewed</div>
                                            </div>
                                            <div className="stepper-item active">
                                                <div className="step-counter"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
                                                    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                </svg></div>
                                                <div className="step-name">Closed</div>
                                            </div>
                                        </div>
                                        </div> */}
                </div>
              </div>
            </div>
            <p className="status-category">Completed</p>
            <div className="assessment-block">
              <div className="illustration-header00">
                <div className="header-meta">
                  <div className="first-divblock">
                    <div>
                      <h3>FY 23-24 Yearly Review</h3>
                      <ul className="basicinfomation">
                        {/* <li><i className="fa fa-calendar" aria-hidden="true"></i>01 Apr 2022- 31 Mar 2023</li> */}
                        <li>
                          <i className="fa fa-user" aria-hidden="true"></i>
                          Total Employee : <b className="emp-count">05</b>
                        </li>
                      </ul>
                    </div>
                    <div className="ml-auto">
                      <span className="assessment-status-close">Closed</span>
                      <Link to="/Assessment/Cycle/CycleGUID">
                      <span className="assessment-view-detail">
                        View Detail
                      </span></Link>
                    </div>
                  </div>
                  <div className="summary-stats">
                    <div className="summary-stat">
                      <img src="images/pms/start-date.svg" />
                      <div>
                        <span>Initiated On</span>
                        <span>08 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/start-date.svg" />
                      <div>
                        <span>Self Assessment By</span>
                        <span>15 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/end-date.svg" />
                      <div>
                        <span>First Review By</span>
                        <span>22 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/date.svg" />
                      <div>
                        <span>Assessment Closure By</span>
                        <span>26 May 2023</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="assessment-block">
              <div className="illustration-header00">
                <div className="header-meta">
                  <div className="first-divblock">
                    <div>
                      <h3>FY 22-23 Yearly Review</h3>
                      <ul className="basicinfomation">
                        {/* <li><i className="fa fa-calendar" aria-hidden="true"></i>01 Apr 2022- 31 Mar 2023</li> */}
                        <li>
                          <i className="fa fa-user" aria-hidden="true"></i>
                          Total Employee : <b className="emp-count">05</b>
                        </li>
                      </ul>
                    </div>
                    <div className="ml-auto">
                      <span className="assessment-status-close">Closed</span>
                     <Link to="/Assessment/Cycle/CycleGUID">
                      <span className="assessment-view-detail">
                        View Detail
                      </span></Link>
                    </div>
                  </div>
                  <div className="summary-stats">
                    <div className="summary-stat">
                      <img src="images/pms/start-date.svg" />
                      <div>
                        <span>Initiated On</span>
                        <span>08 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/start-date.svg" />
                      <div>
                        <span>Self Assessment By</span>
                        <span>15 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/end-date.svg" />
                      <div>
                        <span>First Review By</span>
                        <span>22 May 2023</span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="images/pms/date.svg" />
                      <div>
                        <span>Assessment Closure By</span>
                        <span>26 May 2023</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-3">
            <p className="status-category">Process</p>
            <OwlCarousel
              loop
              margin={10}
              nav
              items={1}
              autoplay={true}
              autoplayTimeout={3000}
              autoplayHoverPause={true}
            >
              <div className="review-step">
                <span>01</span>
                <img
                  src="https://huro.cssninja.io/assets/img/illustrations/widgets/1.svg"
                  style={{ width: "160px", margin: "auto auto 20px" }}
                />
                <h4>Goal Setting</h4>
                <p>
                  Every start of year, set some goals for yourself. Progress is
                  generally good when you follow a goal
                </p>
              </div>
              <div className="review-step">
                <span>02</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/7.svg" />
                <h4>Self Assessment</h4>
                <p>
                  Once review process is started, List down all your success and
                  failures, all good and bad and rate yourself
                </p>
              </div>
              <div className="review-step">
                <span>03</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/8.svg" />
                <h4>Manager Assessment</h4>
                <p>
                  It is managers duty to review your performance without any
                  prejudice. It should be based on actual outcomes of your
                  efforts
                </p>
              </div>
              <div className="review-step">
                <span>04</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/4.svg" />
                <h4>Recomendation</h4>
                <p>
                  Based on your review and your managers assessment, senior
                  management may recommend you new goals, role and
                  responsibilities
                </p>
              </div>
              <div className="review-step">
                <span>05</span>
                <img src="https://huro.cssninja.io/assets/img/illustrations/widgets/7.svg" />
                <h4>One-on-One meeting</h4>
                <p>
                  Use this to discuss all your doubts and chalk out the startegy
                  to do better this year
                </p>
              </div>
            </OwlCarousel>
          </div>
          <div className="col-xl-12 d-none">
            <strong className="assessment-title">Eligible Employees</strong>
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-4">
                  <div className="me-auto w-50">
                    <input
                      type="text"
                      placeholder="search..."
                      className="form-control"
                      style={{ height: "41px" }}
                    />
                  </div>
                  <div className="saving-btn00">
                    <button
                      className="add-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <button
                      className="update-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Update"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </button>
                    <button
                      className="remove-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>
                    <button
                      className="import-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Import"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="export-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="assign-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Assign"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-clipboard-check"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="employee-card tile-grid tile-grid-v1">
                    <div className="table-responsive emp-table">
                      {/* dataTable no-footer */}
                      <table
                        id="example"
                        className="table table-striped table-bordered dataTable no-footer"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "50px" }}>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="checkAll"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkAll"
                                ></label>
                              </div>
                            </th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Assigned To</th>
                            <th>Score</th>
                            <th>Rating</th>
                            <th>Rating Scale</th>
                            <th>First Reviewer</th>
                            <th>Second Reviewer</th>
                            <th>HR</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/6.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Savita Rana
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Closed</td>
                            <td>
                              Arun Mishra
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Vital Performance</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/8.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Sonal</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/1.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Anubhav Singh
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>

                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/2.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Dharmesh tyagi
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/3.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Rashika</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add-new-assessment">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <img src="images/pms/new-assess.gif" />
              <strong className="modal-title text-center d-block">
                Start New Assessment
              </strong>
              <p className=" text-center d-block">
                Do you really want to Report this post ?
              </p>
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Review By</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment Period Start</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment Period End</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment Start</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Assessment End</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Self Assessment Last Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>First Reviewer Last Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HrAssessmentHTML;
